import { Component, Input, OnInit } from '@angular/core';
import { LeadSourceTagsService } from '@features/lead-source-tags/services/lead-source-tags.service';
import { PopoverController } from '@ionic/angular';
import { leadSources } from '@shared/constants/lead-sources';
import { LeadSource } from '@shared/types/lead-source';
import { take } from 'rxjs';

@Component({
  selector: 'app-lead-source-selector',
  templateUrl: './lead-source-selector.component.html',
  styleUrl: './lead-source-selector.component.scss',
  standalone: false,
})
export class LeadSourceSelectorComponent implements OnInit {
  @Input() leadSource: LeadSource | undefined;
  @Input() leadSourceTag: string | undefined;

  leadSourceTagsLoadingState$ = this.leadSourceTagsService.getLeadSourceTagsLoadingState();
  selectedLeadSource: LeadSource | undefined;
  selectedLeadSourceTag: string | undefined;
  leadSources = leadSources;

  constructor(
    private leadSourceTagsService: LeadSourceTagsService,
    private popoverController: PopoverController,
  ) {}

  ngOnInit(): void {
    this.selectedLeadSource = this.leadSource;
    this.selectedLeadSourceTag = this.leadSourceTag;
    this.leadSourceTagsService
      .getLeadSourceTags()
      .pipe(take(1))
      .subscribe((leadSourceTags) => {
        if (leadSourceTags.length === 0) {
          this.leadSourceTagsService.loadLeadSourceTags();
        }
      });
  }

  setLeadSourceAndTag() {
    this.popoverController.dismiss({
      leadSource: this.selectedLeadSource,
      leadSourceTag: this.selectedLeadSourceTag,
    });
  }

  closePopover() {
    this.popoverController.dismiss();
  }
}
